import React from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css'
import { ClompApi } from '../api/ClompApi';
import { SESSION_ENDED_EVENT } from '../api/session';

const api = new ClompApi();

export class Navbar extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            // whether to show the Admin link: only to staff and above
            showAdmin: false
        }
    }

    // The login ran out or was dropped while this page was open: show the logged-out navbar
    onSessionEnded = () => {
        this.setState({ showAdmin: false });
    }

    componentDidMount() {
        window.addEventListener(SESSION_ENDED_EVENT, this.onSessionEnded);
        let token = localStorage.getItem('token');
        if (token === null) {
            return;
        }
        // remembered for the browser session, so each page doesn't ask again
        let key = 'adminAccess:' + token;
        let known = null;
        try { known = sessionStorage.getItem(key); } catch (e) { /* storage unavailable */ }
        if (known !== null) {
            this.setState({ showAdmin: known === 'yes' });
            return;
        }
        this.mounted = true;
        api.admin.getAccess().then((access) => {
            try { sessionStorage.setItem(key, access.allowed ? 'yes' : 'no'); } catch (e) { /* storage unavailable */ }
            if (this.mounted) {
                this.setState({ showAdmin: Boolean(access.allowed) });
            }
        }).catch(() => {});
    }

    componentWillUnmount() {
        this.mounted = false;
        window.removeEventListener(SESSION_ENDED_EVENT, this.onSessionEnded);
    }

    async getUserID() {
        let token = localStorage.getItem('token');
        let userID = await api.auth.getUserByToken(token);
        return userID;
    }

    isLoggedIn = () => {
        if (localStorage.getItem('token') === null) {
            return false;
        }
        return true;
    }

    logout = () => {
        let token = localStorage.getItem('token');
        localStorage.removeItem('token');

        // Remove token from DB
        api.auth.logout(token);

        console.log("Logged out");
        // redirect the user to the homepage
        window.location.href = "/";
    }

    render() {
        return (
            // Create Boostrap navbar with links to /, /games, /news, as well as placeholders for Teams and About. On the right side, there is a login and register button. if the user is logged in, there is a logout button.
            // Wrapper keeps the navbar pinned to the top while the page scrolls
            <div className="mynav-sticky">
            <nav className="navbar navbar-expand-lg navbar-dark bg-black">
                <Link className="navbar-brand" to="/">
                    {/* <img className="navbar-brand-logo" src="img/Clomp-logo.svg" alt="logo" /> */}
                    clomp
                </Link>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav mr-auto">
                        <li className="nav-item">
                            <Link className="nav-link" to="/games">Games</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/cards">Cards</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/leaderboard">Leaderboard</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/news">News</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/about">About</Link>
                        </li>
                        {this.state.showAdmin ?
                            <li className="nav-item">
                                <Link className="nav-link" to="/admin">Admin</Link>
                            </li>
                            : null}
                    </ul>
                    <ul className="navbar-nav ml-auto">
                        <li className="nav-item">
                            {this.isLoggedIn() ?
                                <Link className="nav-link" to={"/profile"}>
                                    <button type="button" className="btn nav-btn nav-btn-primary">Profile</button>
                                </Link>
                                :
                                null
                            }
                        </li>
                        <li className="nav-item">
                            {this.isLoggedIn() ?
                                <Link className="nav-link" to="/">
                                    <button type="button" className="btn nav-btn nav-btn-ghost" onClick={this.logout}>Logout</button>
                                </Link>
                                :
                                <Link className="nav-link" to="/login">
                                    <button type="button" className="btn nav-btn nav-btn-primary">Login</button>
                                </Link>
                            }
                        </li>
                    </ul>
                </div>
            </nav>
            <div className="mynav-bottom"></div>
        </div>)
    }





                // <header class="p-3 bg-dark text-white">
                //     <div class="container">
                //         <div class="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">
                //             <a href="/" class="d-flex align-items-center mb-2 mb-lg-0 text-white text-decoration-none">
                //             <img className="navbar-brand" src="img/Clomp-logo.svg" alt="Clomp.io"></img>
                //             </a>

                //             <ul class="nav col-12 col-lg-auto me-lg-auto mb-2 justify-content-center mb-md-0">
                //                 <li><a href="/" class="nav-link px-2 text-secondary">Home</a></li>
                //                 <li><a href="/games" class="nav-link px-2 text-white">Games</a></li>
                //                 <li><a href="/news" class="nav-link px-2 text-white">News</a></li>
                //                 <li><a href="/" class="nav-link px-2 text-white">FAQs</a></li>
                //                 <li><a href="/" class="nav-link px-2 text-white">About</a></li>
                //             </ul>

                //             <form class="col-12 col-lg-auto mb-3 mb-lg-0 me-lg-3">
                //                 <input type="search" class="form-control form-control-dark" placeholder="Search..." aria-label="Search" />
                //             </form> 

                //             <div class="text-end">
                //                 <Link to="/login">
                //                     <button type="button" class="btn btn-outline-light me-2">Login</button>
                //                 </Link>
                //                 <Link to="/register">
                //                     <button type="button" class="btn btn-warning">Sign-up</button>
                //                 </Link>
                //             </div>
                //         </div>
                //     </div>
                // </header>
        

}